export const datamapImport = {
	selector: {
		container: '.js-upload-question-map',
		modal: '.js-question-map-detail-changes-modal',
	},
}
